import { api } from '@/lib/api';
import type { FiscalRecord } from '@/features/fiscal/schemas';

export interface SignedUrlResponse {
  url: string;
  gcsPath: string;
}

export const nfseApi = {
  signedUrl: (issuanceId: string, kind: 'xml' | 'pdf') =>
    api.get<SignedUrlResponse>(`/nfse/${issuanceId}/${kind}`),

  cancel: (fiscalRecordId: string, reason: string) =>
    api.post<FiscalRecord>(`/fiscal/${fiscalRecordId}/cancel-nfse`, { reason }),
};
